var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 264,
    viewBox: "0 0 115 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 264,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 264,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    width: 5,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26,
    width: 5,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 98,
    width: 5,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 170,
    width: 5,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 62,
    width: 5,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 134,
    width: 5,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 206,
    width: 5,
    height: 20,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunway);
export default __webpack_public_path__ + "static/media/runway.0d3c7f087c85dbc2f77c5643e34b731e.svg";
export { ForwardRef as ReactComponent };